export { default as Text } from './text'
export type { Props as TextProps } from './text'
